import { WifiOff, Wifi } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/use-online-status'
import { useEffect, useState } from 'react'

/**
 * Banner that appears when the user goes offline
 * Shows a reconnection message briefly when coming back online
 */
export function OfflineBanner() {
  const { isOffline, wasOffline, isOnline } = useOnlineStatus()
  const [showReconnected, setShowReconnected] = useState(false)

  useEffect(() => {
    if (wasOffline && isOnline) {
      setShowReconnected(true)
      const timer = setTimeout(() => setShowReconnected(false), 3000)
      return () => clearTimeout(timer)
    }
  }, [wasOffline, isOnline])

  // Show reconnected banner briefly
  if (showReconnected && !isOffline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-green-600 text-white py-2 px-4 text-center flex items-center justify-center gap-2 animate-in slide-in-from-top duration-300">
        <Wifi className="w-4 h-4" />
        <span className="text-sm font-medium">Back online! Connection restored.</span>
      </div>
    )
  }

  // Show offline banner
  if (isOffline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-600 text-white py-2 px-4 text-center flex items-center justify-center gap-2 animate-in slide-in-from-top duration-300">
        <WifiOff className="w-4 h-4" />
        <span className="text-sm font-medium">You're offline. Some features may not work until you reconnect.</span>
      </div>
    )
  }

  return null
}

export default OfflineBanner
